





























































import { SliderVueGB } from "@/extensions/app/SliderVueGB";
import { Component, Watch } from "vue-property-decorator";
import PreApprovedSolutionModal from "@/components/app/PreApprovedSolutionModal.vue"

@Component({
  components: { PreApprovedSolutionModal }
})
export default class SliderAdaptiv extends SliderVueGB {
    /**
 * Список слайдов
 * @returns {Array<any>} - массив объектов.
 */
  get slides(): Array<any> {
    return this.configStore.products;
  }

  approvedSlides: any[] = [];

  sliderPos: number = 0;

  step(flag: boolean): void {
    const length: number = this.slides.length;
    const maxStep: number = Math.round(length / 4) + 1;
    if (flag && this.sliderPos < maxStep) {
      this.sliderPos++;
    } else if (!flag && this.sliderPos > 0) {
      this.sliderPos--;
    }
  }

  @Watch('preApprovedSolutionData', { immediate: true, deep: true })
  onPreApprovedSolutionDataChanged() {
    if (this.preApprovedSolutionData && this.preApprovedSolutionData.length) {
      this.approvedSlides = this.preApprovedSolutionData.map(this.convertPropertiesToSlide);
    }

    this.processPendingSlides();
  }

  removeSlideAdaptiv(slide) {
    const index = this.approvedSlides.findIndex(s => s.Id === slide.Id);
    if (index !== -1) {
      this.approvedSlides.splice(index, 1);
    }
  }

  created() {
    this.approvedSlides = [];
    window.addEventListener("resize", this.updateWidth);
  }
  mounted() {
    this.updateWidth();
  }
}
